module.exports = __webpack_public_path__ + "img/34.863a5fe2.png";